import React from 'react';
import { Grid, Box } from '@mui/material';
import { urlImg, isEmpty } from '../../common/helpers';

const ServiceImages = ({ id, images = [] }) => {
  const count = images.length;
  const getImgUrl = (imgName) => `${urlImg}/servicios/${id}/${imgName}`;

  const base = {
    width: '100%',
    objectFit: 'cover',
    borderRadius: '12px',
    display: 'block',
  };

  // Alturas responsivas: en celular las imágenes se apilan, así que se reducen para no
  // ocupar toda la pantalla; en escritorio conservan la composición original (450px).
  const hMain = { xs: 240, sm: 340, md: 450 };   // imagen principal
  const hHalf = { xs: 200, sm: 240, md: 221 };   // lado apilado (2 verticales)
  const hTop = { xs: 200, sm: 240, md: 255 };    // superior derecha (4 imgs)
  const hSmall = { xs: 150, sm: 190, md: 187 };  // inferiores en 2 columnas

  // Sin imágenes — placeholder único
  if (count === 0) {
    return (
      <Box component="img" src="/search.png" alt="Sin imagen"
        sx={{ ...base, height: hMain, mb: 1 }} />
    );
  }

  // 1 imagen — ocupa todo el ancho disponible
  if (count === 1) {
    return (
      <Box component="img" src={getImgUrl(images[0].nombre)} alt="Principal"
        sx={{ ...base, height: hMain, mb: 1 }} />
    );
  }

  // 2 imágenes — principal más ancha + secundaria al lado
  if (count === 2) {
    return (
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid size={{ xs: 12, md: 8 }}>
          <Box component="img" src={getImgUrl(images[0].nombre)} alt="Principal"
            sx={{ ...base, height: hMain }} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box component="img" src={getImgUrl(images[1].nombre)} alt="Imagen 2"
            sx={{ ...base, height: { xs: 200, sm: 240, md: 450 } }} />
        </Grid>
      </Grid>
    );
  }

  // 3 imágenes — grande izquierda + 2 apiladas derecha
  if (count === 3) {
    return (
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid size={{ xs: 12, md: 7 }}>
          <Box component="img" src={getImgUrl(images[0].nombre)} alt="Principal"
            sx={{ ...base, height: hMain }} />
        </Grid>
        <Grid size={{ xs: 12, md: 5 }}>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12 }}>
              <Box component="img" src={getImgUrl(images[1].nombre)} alt="Imagen 2"
                sx={{ ...base, height: hHalf }} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Box component="img" src={getImgUrl(images[2].nombre)} alt="Imagen 3"
                sx={{ ...base, height: hHalf }} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  // 4 imágenes — grande izquierda + 1 arriba derecha + 2 abajo derecha
  if (count === 4) {
    return (
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid size={{ xs: 12, md: 7 }}>
          <Box component="img" src={getImgUrl(images[0].nombre)} alt="Principal"
            sx={{ ...base, height: hMain }} />
        </Grid>
        <Grid size={{ xs: 12, md: 5 }}>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12 }}>
              <Box component="img" src={getImgUrl(images[1].nombre)} alt="Imagen 2"
                sx={{ ...base, height: hTop }} />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <Box component="img" src={getImgUrl(images[2].nombre)} alt="Imagen 3"
                sx={{ ...base, height: hSmall }} />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <Box component="img" src={getImgUrl(images[3].nombre)} alt="Imagen 4"
                sx={{ ...base, height: hSmall }} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  // 5+ imágenes — layout completo: grande izquierda + grid 2x2 derecha
  return (
    <Grid container spacing={1} sx={{ mb: 1 }}>
      <Grid size={{ xs: 12, md: 7 }}>
        <Box component="img" src={getImgUrl(images[0].nombre)} alt="Principal"
          sx={{ ...base, height: hMain }} />
      </Grid>
      <Grid size={{ xs: 12, md: 5 }}>
        <Grid container spacing={1}>
          {images.slice(1, 5).map((img, i) => (
            <Grid size={{ xs: 6 }} key={i}>
              <Box component="img" src={getImgUrl(img.nombre)} alt={`Imagen ${i + 2}`}
                sx={{ ...base, height: hHalf }} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ServiceImages;
